"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsDevService = void 0;
const tiny_emitter_1 = require("tiny-emitter");
const feature_flags_service_1 = require("./feature-flags-service");
const DEFAULT_EDITOR_URL = 'https://staging-api.easygenerator.com';
const SETTINGS_URL_PATHNAME = '/api/v1/application/settings';
class FeatureFlagsDevService {
    constructor() {
        this.emitter = new tiny_emitter_1.TinyEmitter();
        this.getFeatureFlagsSettings()
            .then(settings => {
            if (!settings.featureFlagsServiceUrl) {
                throw new Error('Feature flags settings missing (featureFlagsServiceUrl)');
            }
            if (!settings.featureFlagsClientKey) {
                throw new Error('Feature flags settings missing (featureFlagsClientKey)');
            }
            this.serviceInstance = new feature_flags_service_1.FeatureFlagsService({
                serviceUrl: settings.featureFlagsServiceUrl,
                clientKey: settings.featureFlagsClientKey,
                applicationName: 'localhost',
                refreshIntervalInSeconds: 15,
                accountId: '00000000-0000-0000-0000-000000000000'
            });
            this.serviceInstance.on('ready', () => this.emitter.emit('ready'));
            this.serviceInstance.on('update', () => this.emitter.emit('update'));
            this.serviceInstance.on('error', () => this.emitter.emit('error'));
        })
            .catch(error => {
            console.error(`Error during FeatureFlagsDevService initialization: ${error}`);
        });
    }
    isFeatureEnabled(featureName) {
        if (this.serviceInstance) {
            return this.serviceInstance.isFeatureEnabled(featureName);
        }
        return false;
    }
    on(eventName, callback) {
        this.emitter.on(eventName, callback);
    }
    off(eventName, callback) {
        this.emitter.off(eventName, callback);
    }
    getSettingsUrl() {
        var _a;
        const url = new URL((_a = window.editorServiceUrl) !== null && _a !== void 0 ? _a : DEFAULT_EDITOR_URL);
        url.pathname = SETTINGS_URL_PATHNAME;
        return url.toString();
    }
    async getFeatureFlagsSettings() {
        const settingsUrl = this.getSettingsUrl();
        const response = await fetch(settingsUrl);
        const settings = await response.json();
        return {
            featureFlagsServiceUrl: this.getSettingsOption(settings, 'featureFlagsServiceUrl'),
            featureFlagsClientKey: this.getSettingsOption(settings, 'featureFlagsClientKey')
        };
    }
    getSettingsOption(settings, key) {
        var _a;
        return (_a = settings === null || settings === void 0 ? void 0 : settings.find(item => (item === null || item === void 0 ? void 0 : item.key) === key)) === null || _a === void 0 ? void 0 : _a.value;
    }
}
exports.FeatureFlagsDevService = FeatureFlagsDevService;
